// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"TransactionsHistoryNFT_scrollbar__FZIUQ"};